/*
  JC_DO_PDP_CHECKOUT_01 — add to cart goes straight to checkout, no drawer.

  Dormant until a visitor is armed. Armed visitors keep the flag for the whole
  session, so it survives the landing page -> product page hop and a back button
  out of checkout. Control is untouched: nothing below runs without the flag.

  Arming, any of these:
    - window.jcDirectCheckout.arm()   <- what the Intelligems variation calls on the landing page
    - ?jc_dc=1 on any URL             <- QA and preview
    - class "jc-direct-checkout" on <html>
  Disarming: window.jcDirectCheckout.disarm() or ?jc_dc=0.

  Armed visitors also see the add to cart button relabelled to "Ga verder naar
  afrekenen": the button has to say what it does, or the test measures a broken
  promise instead of a removed step.
*/
(function () {
  var TEST = 'JC_DO_PDP_CHECKOUT_01';
  var FLAG = 'jc-direct-checkout';
  var KEY = 'jc_direct_checkout';
  // Resolved on each call: the script can be evaluated before <html> exists.
  function root() { return document.documentElement; }
  // Set while we re-submit a form after our own path failed, so we stand aside.
  var bypass = false;

  function store(value) {
    try { window.sessionStorage.setItem(KEY, value); } catch (e) {}
  }

  function armed() {
    var html = root();
    if (html && html.classList.contains(FLAG)) return true;
    try {
      if (window.sessionStorage.getItem(KEY) === '1') {
        if (html) html.classList.add(FLAG);
        return true;
      }
    } catch (e) {}
    return false;
  }

  function arm() {
    var html = root();
    if (html) html.classList.add(FLAG);
    store('1');
    silenceDrawer();
    relabel();
  }

  function disarm() {
    var html = root();
    if (html) html.classList.remove(FLAG);
    store('0');
    unlabel();
  }

  function readParam() {
    try {
      var value = new URLSearchParams(window.location.search).get('jc_dc');
      if (value === '1') arm();
      if (value === '0') disarm();
    } catch (e) {}
  }

  // The visitor is leaving the page anyway, so the drawer must never get its
  // moment. Taking auto-open off the element is cheaper than racing its listener.
  function silenceDrawer() {
    if (!armed()) return;
    var drawers = document.querySelectorAll('cart-drawer-component[auto-open]');
    [].forEach.call(drawers, function (drawer) { drawer.removeAttribute('auto-open'); });
  }

  // Daniel: a button that says "add to cart" and lands on checkout is misleading.
  // Roald settled the wording: continue to checkout. Armed visitors only, so
  // control keeps the theme's own label.
  //
  // The label is rewritten in three places because three things own it:
  //   - the visible span the theme renders
  //   - data-kaching-atc-label, which the Kaching bundles app reads back when it
  //     re-renders the button, and would otherwise restore the old text
  //   - the accessible name, so a screen reader is not told something different
  //     from what the button does
  var LABEL = 'Ga verder naar afrekenen';

  function labelTargets() {
    // The main buy box only. The 6 other /cart/add forms on a product page sit
    // inside the cart drawer's recommendations and are not eligible, and the
    // sticky bar's button is a scroll-to-buy-box, not an add to cart.
    return document.querySelectorAll('[data-kaching-atc-button]');
  }

  function relabel() {
    if (!armed()) return;
    [].forEach.call(labelTargets(), function (button) {
      if (button.dataset.jcLabel === LABEL) return;
      var slot = button.querySelector('.add-to-cart-text__content span') ||
                 button.querySelector('.add-to-cart-text__content');
      if (!slot) return;
      if (!button.dataset.jcLabelWas) {
        button.dataset.jcLabelWas = slot.textContent.trim();
      }
      slot.textContent = LABEL;
      button.setAttribute('data-kaching-atc-label', LABEL);
      if (button.hasAttribute('aria-label')) button.setAttribute('aria-label', LABEL);
      button.dataset.jcLabel = LABEL;
    });
  }

  function unlabel() {
    [].forEach.call(labelTargets(), function (button) {
      var was = button.dataset.jcLabelWas;
      if (!was) return;
      var slot = button.querySelector('.add-to-cart-text__content span') ||
                 button.querySelector('.add-to-cart-text__content');
      if (slot) slot.textContent = was;
      button.setAttribute('data-kaching-atc-label', was);
      if (button.hasAttribute('aria-label')) button.setAttribute('aria-label', was);
      delete button.dataset.jcLabel;
      delete button.dataset.jcLabelWas;
    });
  }

  // A variant switch re-renders the buy box and Kaching rewrites the label after
  // its own bundle logic runs, so a one-shot relabel on load does not hold.
  function watchLabel() {
    if (!window.MutationObserver) return;
    new MutationObserver(function () { relabel(); })
      .observe(document.documentElement, { childList: true, subtree: true });
  }

  function checkoutUrl() {
    var cart = (window.Theme && Theme.routes && Theme.routes.cart_url) || '/cart';
    return cart.replace(/\/cart\/?$/, '') + '/checkout';
  }

  function track(step) {
    try {
      if (window.dataLayer && window.dataLayer.push) {
        window.dataLayer.push({ event: 'jc_direct_checkout', jc_test: TEST, jc_step: step });
      }
    } catch (e) {}
  }

  // Only the product page's own add to cart. Quick add on a card and anything
  // inside the drawer keep the normal behaviour.
  function eligibleForm(form) {
    if (!form || bypass || form.dataset.jcInFlight === 'true' || !armed()) return false;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return false;
    if (form.closest('product-card, .quick-add-modal, cart-drawer-component')) return false;
    return !!form.querySelector('[name="id"]');
  }

  function busy(form, on) {
    var button = form.querySelector('[ref="addToCartButton"], [type="submit"]');
    if (!button) return;
    if (on) {
      button.setAttribute('aria-busy', 'true');
      button.dataset.added = 'true';
    } else {
      button.removeAttribute('aria-busy');
      button.removeAttribute('data-added');
    }
  }

  function json(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  // Coming back out of checkout and pressing add to cart again must not stack a
  // second unit. The line is set to the quantity asked for, not incremented.
  function existingLine(cart, variantId, sellingPlan) {
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i += 1) {
      var item = items[i];
      if (String(item.variant_id) !== variantId) continue;
      var plan = item.selling_plan_allocation ? String(item.selling_plan_allocation.selling_plan.id) : '';
      if (plan === sellingPlan) return item;
    }
    return null;
  }

  function submitNormally(form) {
    bypass = true;
    if (form.requestSubmit) form.requestSubmit();
    else form.submit();
    bypass = false;
  }

  function toCheckout(form) {
    var data = new FormData(form);
    var variantId = String(data.get('id') || '');
    var quantity = Number(data.get('quantity')) || 1;
    var sellingPlan = String(data.get('selling_plan') || '');
    if (!variantId) return submitNormally(form);

    form.dataset.jcInFlight = 'true';
    busy(form, true);
    track('click');

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var line = existingLine(cart, variantId, sellingPlan);
        if (line && line.quantity >= quantity) return null;
        if (line) return json('/cart/change.js', { id: line.key, quantity: quantity });
        return fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: data })
          .then(function (r) { return r.json(); })
          .then(function (response) {
            if (response && response.status) throw new Error(response.description || response.message);
            return response;
          });
      })
      .then(function () {
        track('redirect');
        window.location.href = checkoutUrl();
      })
      .catch(function (error) {
        // Never leave the visitor on a dead button: hand the click back to the
        // theme, which shows the real error and opens the drawer as usual.
        delete form.dataset.jcInFlight;
        busy(form, false);
        track('fallback');
        if (window.console) console.warn('[' + TEST + '] falling back to the cart drawer', error);
        submitNormally(form);
      });
  }

  // The click is taken, not the submit. The theme binds its own handler on the
  // button's component, so a submit-phase intercept can land after the theme has
  // already posted its own /cart/add and the visitor reaches checkout with two
  // units. Killing the click at document level always runs first, because the
  // theme's listener sits on a deeper node, and no submit event is ever fired.
  document.addEventListener(
    'click',
    function (event) {
      var button = event.target.closest && event.target.closest('button, input[type="submit"]');
      if (!button || (button.type && button.type !== 'submit')) return;
      var form = button.form || button.closest('form');
      if (!form) return;
      // A second tap while our own add is in flight has to be swallowed, not
      // handed back to the theme: the theme would post its own /cart/add and
      // the visitor reaches checkout with double the units.
      if (form.dataset.jcInFlight === 'true') {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
      if (!eligibleForm(form)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      toCheckout(form);
    },
    true
  );

  // Backstop for a keyboard submit, which never produces a click.
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form) return;
      if (form.dataset && form.dataset.jcInFlight === 'true') {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
      if (!eligibleForm(form)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      toCheckout(form);
    },
    true
  );

  window.jcDirectCheckout = { arm: arm, disarm: disarm, armed: armed, test: TEST };

  readParam();
  silenceDrawer();
  relabel();
  watchLabel();
  document.addEventListener('DOMContentLoaded', function () {
    silenceDrawer();
    relabel();
  });
})();
